import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import React, { Fragment, useEffect, useState } from 'react';

import { isEmpty } from '../../../helpers/isEmpty';
import Stepper from './Stepper';

interface IPromptDialog {
    setInitialSettings: Function;
    alertUser: any;
    handleClose: any;
    handleSave: Function;
    activeEvent: any;
}
export default function PromptDialog(props: IPromptDialog) {
    const { activeEvent, alertUser, handleClose } = props;
    const [open, setOpen] = useState(false);

    const useStyles = makeStyles(theme => ({
        formControl: {
            margin: theme.spacing(1),
        },
        input: {
            display: 'none',
        },
        progress: {
            margin: '5px 0',
            padding: '5px 0',
        },
    }));

    useEffect(() => {
        //To determine whether to show the dialog or not
        if (
            !(localStorage.getItem(`CC-${activeEvent.id}-onboarding`) === 'skipped') &&
            alertUser.fetched &&
            (isEmpty(alertUser.name) ||
                isEmpty(activeEvent.heroImage) ||
                isEmpty(alertUser.profileImage) ||
                isEmpty(alertUser.profileImageThumbnail))
        ) {
            setOpen(true);
        } else {
            setOpen(false);
        }
        // eslint-disable-next-line
    }, [alertUser, activeEvent.heroImage, alertUser.profileImage]);
    const closeModal = () => {
        setOpen(false);
    };
    const classes = useStyles();

    return (
        <div>
            <Dialog aria-labelledby="form-dialog-title" onClose={handleClose} open={open}>
                <DialogTitle id="form-dialog-title">Let's get you setup!</DialogTitle>
                <DialogContent style={{ paddingBottom: 10 }}>
                    <DialogContentText>
                        Before you can begin using the Command Center, you must complete this brief setup.
                    </DialogContentText>
                    <Stepper closeModal={closeModal} {...props} />
                    {alertUser.onboardingSaving && (
                        <Fragment>
                            <Typography>Saving...</Typography>
                            <LinearProgress
                                className={classes.progress}
                                color="secondary"
                                value={alertUser.onboardingSaving}
                                variant="determinate"
                            />
                        </Fragment>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
}
